import React from 'react';
import '../styles/landing.css';

const Features = () => {
  return (
    <>
      {/* Premium Features Section */}
      <section className="features premium-features" id="features">
        <div className="container">
          <h2 className="section-title">Your Smart Interview Prep Companion</h2>
          <p className="section-subtitle">
            Daily bite-sized prep that prevents burnout and builds consistency
          </p>

          <div className="premium-features-grid">
            {/* PrepLetters Feature */}
            <div className="premium-feature-card fade-in-up">
              <div className="premium-feature-header">
                <div className="premium-feature-icon">📚</div>
                <h3>100+ PrepLetters Across 4 Languages</h3>
              </div>
              <p className="premium-feature-description">
                Access our complete library of interview prep content in Python, JavaScript, Java, and C++
              </p>
              <div className="feature-examples">
              <div className="example-tag">🐍 Python</div>
                <div className="example-tag">🟨 JavaScript</div>
                <div className="example-tag">☕ Java</div>
                <div className="example-tag">⚡ C++</div>
              </div>
              <div className="feature-highlight">Browse & Complete at Your Own Pace</div>
            </div>

            {/* Interactive Quiz System */}
            <div className="premium-feature-card fade-in-up">
              <div className="premium-feature-header">
                <div className="premium-feature-icon">🎯</div>
                <h3>Interactive Quiz System</h3>
              </div>
              <p className="premium-feature-description">
                Daily quizzes after each letter with comprehensive progress tracking and retake opportunities
              </p>
              <div className="feature-examples">
                <div className="example-tag">📊 Best Score Tracking</div>
                <div className="example-tag">🔄 Unlimited Retakes</div>
                <div className="example-tag">📈 Performance Analytics</div>
                <div className="example-tag">🏆 Achievement System</div>
              </div>
              <div className="feature-highlight">Master Every Concept Thoroughly</div>
            </div>

            {/* Smart Email System */}
            <div className="premium-feature-card fade-in-up">
              <div className="premium-feature-header">
                <div className="premium-feature-icon">📧</div>
                <h3>Smart Email Delivery System</h3>
              </div>
              <p className="premium-feature-description">
                Personalized delivery schedule with smart accountability tracking
              </p>
              <div className="feature-examples">
                <div className="example-tag">⏰ Custom Time & Timezone</div>
                <div className="example-tag">📅 1-7 Day Frequency</div>
                <div className="example-tag">👁️ Email Open Tracking</div>
                <div className="example-tag">🔄 Auto-Pause Feature</div>
              </div>
              <div className="feature-highlight">Never Miss Your Learning Goal</div>
            </div>

            {/* Zero Burnout Approach */}
            <div className="premium-feature-card fade-in-up">
              <div className="premium-feature-header">
                <div className="premium-feature-icon">🧘‍♂️</div>
                <h3>Zero Burnout Learning</h3>
              </div>
              <p className="premium-feature-description">
                Bite-sized daily content that builds consistency without overwhelming you
              </p>
              <div className="feature-examples">
                <div className="example-tag">⏱️ 5 Minutes Daily</div>
                <div className="example-tag">🎯 Focused Learning</div>
                <div className="example-tag">🔄 Sustainable Pace</div>
                <div className="example-tag">💪 Long-term Retention</div>
              </div>
              <div className="feature-highlight">Stay Motivated Without Stress</div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits of Daily Practice Section */}
      <section className="features" style={{ background: '#1a2234' }}>
        <div className="container">
          <h2 className="section-title">Benefits of Daily Practice</h2>
          <p className="section-subtitle">
            Consistency is key to mastering technical interviews without burnout
          </p>

          <div className="features-grid">
            <div className="feature-card fade-in-up">
              <div className="feature-icon">🧩</div>
              <h3>Pattern Recognition</h3>
              <p>
                Learn to recognize problem patterns that can be applied across similar challenges
              </p>
            </div>

            <div className="feature-card fade-in-up">
              <div className="feature-icon">📈</div>
              <h3>Consistent Improvement</h3>
              <p>
                Daily practice builds a habit of continuous learning and skill development
              </p>
            </div>

            <div className="feature-card fade-in-up">
              <div className="feature-icon">💪</div>
              <h3>Confidence Building</h3>
              <p>
                Gain confidence as you master problem-solving techniques across different contexts
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Features;
